import '../scss/frontpage.scss';
// document.addEventListener("DOMContentLoaded", function() {
//     const numItems = 50; // Total number of items you want to create
//     const totalDuration = 5; // Total duration of each item's animation in seconds
//     const itemsOnScreen = 5; // Max number of items you want on the screen at once
//     const delayIncrement = totalDuration / itemsOnScreen; // Delay between each item's start
    
//     // Paths the items can follow
//     const paths = ['path1', 'path2', 'path3'];

//     paths.forEach(path => {
//         const container = document.querySelector('.data-flow'); // Get the container
//         const template = container.querySelector(`.data-item.${path}.template`);

//         for (let i = 0; i < numItems; i++) {
//             const newItem = template.cloneNode(true); // Create a new item based on the template
//             newItem.classList.remove('template'); // Remove the template class
//             newItem.style.animationDelay = `${i * delayIncrement}s`; // Set the animation delay
//             container.appendChild(newItem); // Add the new item to the container
//         }
//     });

//     // Optionally remove the original template items
//     document.querySelectorAll('.data-item.template').forEach(template => {
//         template.parentNode.removeChild(template);
//     });
// });

// let sliderInput = document.getElementById('comparison-slider-input');

// let overlayImage = document.getElementById('overlay-img');
// let dragLine = document.getElementById('drag-line');

// sliderInput.oninput = () =>{
//     let sliderVal = sliderInput.value;
//     dragLine.style.left = sliderVal + "%";
//     overlayImage.style.width = sliderVal + "%";

//     console.log(sliderVal);
// }
// let tl = gsap.timeline({
// 	scrollTrigger: {
// 		trigger: ".pix-hero-home",
// 		pin: true,
// 		start: "0",
// 		end: "bottom",
// 		scrub: true,

// 	},
// });

// //Check screen size for correct animation
// let screenSize = document.documentElement.clientWidth || window.innerWidth;

// console.log(screenSize);

// if (screenSize <= 768) {
// 	tl.fromTo(".pixelhackers-dripping-arrow", {opacity:1},{opacity:0, duration: 0.5});
	
// 	tl.fromTo(".pix-hero-device", {opacity:0},{opacity:1, duration: 1});
// 	tl.fromTo(".pix-hero-home__content", { },{scale:0.666, duration: 2}, "-=1");
// 	tl.fromTo(".pix-hero-device", {scale:1.5},{scale:1, duration: 2}, "-=2");
// } else {
// 	tl.fromTo(".pix-hero-device", {opacity:0},{opacity:1, duration: 1});
// 	tl.fromTo(".pixelhackers-dripping-arrow", {opacity:1},{opacity:0, duration: 0.5});
// 	tl.fromTo(".pix-hero-home__content", { },{scale: 0.5, duration: 2}, "-=1");
// 	tl.fromTo(".pix-hero-device", {scale:1.75},{scale:0.88, duration: 2}, "-=2");
// };

document.addEventListener('DOMContentLoaded', function () {
    const tabCards = document.querySelectorAll('.tab-card');
    const tabContents = document.querySelectorAll('.tab-content');
    const mediaContents = document.querySelectorAll('.tab-media');

    tabCards.forEach((card, index) => {
        const button = card.querySelector('.tab-button');
        const content = card.querySelector('.tab-content');
        const media = document.getElementById(`media-tab-${index}`);

        button.addEventListener('click', function () {
            // If the clicked tab is already active, do nothing
            if (content.classList.contains('active')) {
                return;
            }

            // Reset all tabs and media sections
            tabContents.forEach(tc => tc.classList.remove('active'));
            mediaContents.forEach(mc => mc.classList.remove('active'));

            // Activate the clicked tab's content and media
            content.classList.add('active');
            if (media) {
                media.classList.add('active');
            }
        });
    });

    // Activate the first tab and media by default
    if (tabCards.length) {
        tabCards[0].querySelector('.tab-button').click();
    }
});

// document.addEventListener("DOMContentLoaded", () => {
//     const cards = document.querySelectorAll(".problem-card");
  
//     // Function to shuffle an array (Fisher-Yates shuffle)
//     function shuffleArray(array) {
//       for (let i = array.length - 1; i > 0; i--) {
//         const j = Math.floor(Math.random() * (i + 1));
//         [array[i], array[j]] = [array[j], array[i]];
//       }
//       return array;
//     }
  
//     // Function to initialize the sequence for a card
//     function initializeSequence(card) {
//       const sequence = ["statement_1", "blank", "statement_2", "statement_3"];
//       card.dataset.sequence = JSON.stringify(shuffleArray(sequence)); // Store the sequence as JSON
//       card.dataset.sequenceIndex = 0; // Start at the first state
//     }
  
//     // Function to update the card's state based on its sequence
//     function updateCardState(card) {
//       const sequence = JSON.parse(card.dataset.sequence); // Get the sequence
//       const currentIndex = parseInt(card.dataset.sequenceIndex, 10); // Get the current index
//       const nextIndex = (currentIndex + 1) % sequence.length; // Move to the next index in the sequence
  
//       card.dataset.state = sequence[nextIndex]; // Update the card's state
//       card.dataset.sequenceIndex = nextIndex; // Save the updated index
  
//       updateCardContent(card); // Update the content visibility
//     }
  
//     // Function to update the visibility of spans based on the current state
//     function updateCardContent(card) {
//       const currentState = card.dataset.state;
  
//       // Hide all spans inside the card
//       const spans = card.querySelectorAll(".state");
//       spans.forEach((span) => {
//         span.style.display = "none";
//       });
  
//       // Show the span matching the current state
//       const activeSpan = card.querySelector(`.state[data-state="${currentState}"]`);
//       if (activeSpan) {
//         activeSpan.style.display = "inline";
//       }
//     }
  
//     // Function to set a random interval for each card
//     function setRandomInterval(card) {
//       const interval = Math.floor(Math.random() * (7000 - 3000 + 1)) + 3000; // Random interval between 3-7 seconds
//       setTimeout(() => {
//         updateCardState(card); // Update the state based on the sequence
//         setRandomInterval(card); // Reapply random interval
//       }, interval);
//     }
  
//     // Initialize all cards
//     cards.forEach((card) => {
//       initializeSequence(card); // Set a random sequence for each card
//       updateCardContent(card); // Initialize content visibility
//       setRandomInterval(card); // Start random state toggling
//     });
//   });
  
document.addEventListener("DOMContentLoaded", () => {
    const cards = document.querySelectorAll(".problem-card");
  
    // Function to shuffle an array (Fisher-Yates shuffle)
    function shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    }
  
    // Function to initialize the sequence for a card
    function initializeSequence(card) {
      const sequence = ["statement_1", "blank", "statement_2", "statement_3"];
      card.dataset.sequence = JSON.stringify(shuffleArray(sequence)); // Store the sequence as JSON
      card.dataset.sequenceIndex = 0; // Start at the first state
    }
  
    // Function to update the card's state based on its sequence
    function updateCardState(card) {
      const sequence = JSON.parse(card.dataset.sequence); // Get the sequence
      const currentIndex = parseInt(card.dataset.sequenceIndex, 10); // Get the current index
      const nextIndex = (currentIndex + 1) % sequence.length; // Move to the next index in the sequence
  
      const currentState = card.dataset.state;
      const nextState = sequence[nextIndex];
  
      card.dataset.state = nextState; // Update the card's state
      card.dataset.sequenceIndex = nextIndex; // Save the updated index
  
      applyAnimation(card, currentState, nextState); // Apply rolling animation
      updateCardContent(card); // Update the content visibility
    }
  
    // Function to update the visibility of spans based on the current state
    function updateCardContent(card) {
      const currentState = card.dataset.state;
  
      // Hide all spans inside the card
      const spans = card.querySelectorAll(".state");
      spans.forEach((span) => {
        span.style.display = "none";
      });
  
      // Show the span matching the current state
      const activeSpan = card.querySelector(`.state[data-state="${currentState}"]`);
      if (activeSpan) {
        activeSpan.style.display = "inline";
      }
    }
  
    // Function to apply rolling animation
    function applyAnimation(card, currentState, nextState) {
      const activeSpan = card.querySelector(`.state[data-state="${nextState}"]`);
  
      if (currentState === "blank" && nextState !== "blank") {
        // Roll down when transitioning from blank to any statement
        activeSpan.classList.add("rolling-down");
      } else if (currentState !== "blank" && nextState === "blank") {
        // Roll up when transitioning from any statement to blank
        activeSpan.classList.add("rolling-up");
      } else {
        // Default to rolling down for other transitions
        activeSpan.classList.add("rolling-down");
      }
  
      // Remove animation class after the animation ends
      activeSpan.addEventListener(
        "animationend",
        () => {
          activeSpan.classList.remove("rolling-up", "rolling-down");
        },
        { once: true } // Ensure the listener is removed after execution
      );
    }
  
    // Function to set a random interval for each card
    function setRandomInterval(card) {
      const interval = Math.floor(Math.random() * (7000 - 3000 + 1)) + 3000; // Random interval between 3-7 seconds
      setTimeout(() => {
        updateCardState(card); // Update the state based on the sequence
        setRandomInterval(card); // Reapply random interval
      }, interval);
    }
  
    // Initialize all cards
    cards.forEach((card) => {
      initializeSequence(card); // Set a random sequence for each card
      updateCardContent(card); // Initialize content visibility
      setRandomInterval(card); // Start random state toggling
    });
  });
  